import BaseComponent from "../../baseComponent.js";

export default class  Sidenav extends BaseComponent {
  constructor(props) {
    super(props);
    this.opacity = props.opacity == null ? 0.16 : props.opacity;
  }

  componentDidMount() {
    this.$container = $(this.refs.container);
    this.parentOverflowY = this.$container.parent().css("overflow-y");
  }

  showSideNav() {
    let isOpen = this.refs.sideNav.classList.contains("slide-in");
    if (!isOpen) {
      this.$container.parent().css("overflow-y", "hidden");
      this.refs.sideNav.setAttribute("class", "slide-in");
      this.refs.backDrop.style.display = "block";
      this.refs.container.style.zIndex = 100;
    }
  }

  hideSideNav() {
    let isOpen = this.refs.sideNav.classList.contains("slide-in");
    if (isOpen) {
      this.$container.parent().css("overflow-y", this.parentOverflowY);
      this.refs.sideNav.setAttribute("class", "slide-out");
      this.refs.backDrop.style.display = "none";
      setTimeout(() => {
        this.refs.container.style.zIndex = -1;
      }, 500);
    }
  }

  render() {
    let containerStyle = {
      position: "absolute",
      width: "100%",
      height: "100%",
      top: 0,
      right: 0,
      zIndex: -1,
      overflowX: "hidden"
    };

    let sideNavStyle = {
      width: this.props.width + "px" || "250px",
      background: "white",
      position: "absolute",
      top: 0,
      right: 0,
      zIndex: 100,
      boxShadow: "0 2px 5px 0 rgba(0,0,0,0.16),0 2px 10px 0 rgba(0,0,0,0.12)",
      transform: "translateX(101%)",
      padding: "16px 24px",
      height: "100%",
      overflowY: "auto"
    };

    let backdrop = {
      position: "absolute",
      width: "100%",
      height: "100%",
      display: "none",
      top: 0,
      right: 0,
      backgroundColor: "rgba(0, 0, 0, " + this.opacity + ")"
    };

    return (
      <div ref="container" style={containerStyle}>
        <div ref="sideNav" style={sideNavStyle}>
          {this.props.children}
        </div>
        <div ref="backDrop" style={backdrop} onClick={(e) => this.hideSideNav(e)}>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/common/sidenav/sidenav.jsx